import { Grid } from "@mui/material";
import ContentSection from "../../ContentSection";
import MxFormL3RushRadioDuoField from "@rf-l3/form/MxFormL3RushRadioDuo";
import MxFormL3TextDateField from "@rf-l3/form/MxFormL3DatePickerField";
import MxFormL4DocumentFileProperty from "@/src-refactor/modules/shared/components/refactor/components/l4/form/MxFormL4DocumentFileProperty";
import useAcoprovi from "../../hooks/useAcoprovi";
import MxTypography from "@rf-l1/MxTypography";
import { useFormValidationsDocumentsMsgSlice } from "@rf/property/module/components/property-form/store/slices/form-validations-documents-msg/FormValidationsDocumentsMsgSlice";
import { A_APROCOVICI } from "../../models/acoprivi.const";
import useMediaQuery from "@/shared/hooks/use-media-query";
import MxFormL3AutoComplete from "@rf-l3/form/MxForml3AutoComplete";
import useValidateExplicitField from "../../hooks/useValidateExplicitField";
import useShowValidationInfo from "@rf/property/module/components/modal/useShowValidationInfo";
import { IFileData } from "@rf-l1/file/helpers/create-file-data";
import { CPropertyValidationDocumentKeys } from "@rf/property/module/components/property-form/util/schemas/validation-documents/validation-document.schema";
import { CValidationDocumentKeys } from "../../../../../../../util/model/documents-types";

function Aprocovici() {
  const { isMobile } = useMediaQuery();
  const { isAcoprovi, isAprocovici, not } = useAcoprovi();
  const {
    validationDocuments: { acoprovi, aprocovici }
  } = useFormValidationsDocumentsMsgSlice();
  const { validateField } = useValidateExplicitField();
  const { showNotification } = useShowValidationInfo();

  const handleOnClickOnExternalIndicators = (
    file: IFileData | null,
    ctx: any,
    itemCtx: any
  ) => {
    showNotification(itemCtx.msg, itemCtx.status);
  };
  return (
    <Grid container item xs={12}>
      {!isMobile && (
        <Grid item maxWidth={600} minWidth={600}>
          <MxFormL3RushRadioDuoField
            withreacthookform={1}
            items={A_APROCOVICI}
            label=" ¿A que asociación pertenece?"
            name={CPropertyValidationDocumentKeys.type_association_acoprovi}
          />
        </Grid>
      )}
      {isMobile && (
        <Grid item xs={12}>
          <MxFormL3AutoComplete
            withreacthookform={1}
            items={A_APROCOVICI}
            label=" ¿A que asociación pertenece?"
            name={CPropertyValidationDocumentKeys.type_association_acoprovi}
          />
        </Grid>
      )}

      {!not && (
        <Grid item xs={12}>
          <ContentSection
            title="APROCOVICI o ACOPROVI"
            tooltip="Aprocovici o Acoprovi"
            color="blue"
            alert={aprocovici?.alert || acoprovi?.alert}
          >
            <Grid container item xs={12} columnGap={1}>
              {isAcoprovi && (
                <Grid container item xs={3} rowGap={1}>
                  <Grid item xs={12} rowGap={1}>
                    <MxFormL4DocumentFileProperty
                      name={CPropertyValidationDocumentKeys.file_acoprovi}
                      label="Subir imagen de pertenencia a ACOPROVI"
                      maxSize={3}
                      minSize={0}
                      withreacthookform={1}
                      disabled={acoprovi?.disabled}
                      typeKey={CValidationDocumentKeys.Acoprovi}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <MxFormL3TextDateField
                      withreacthookform={1}
                      name={CPropertyValidationDocumentKeys.date_file_acoprovi}
                      label="Fecha de ingreso"
                      disabled={acoprovi?.disabled}
                    />
                  </Grid>
                </Grid>
              )}

              {isAprocovici && (
                <Grid container item xs={3} rowGap={1}>
                  <Grid item xs={12}>
                    <MxFormL4DocumentFileProperty
                      name={CPropertyValidationDocumentKeys.file_aprocovici}
                      label="Subir imagen de pertenencia a APROCOVICI"
                      maxSize={3}
                      minSize={0}
                      withreacthookform={1}
                      disabled={aprocovici?.disabled}
                      typeKey={CValidationDocumentKeys.Aprocovici}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <MxFormL3TextDateField
                      withreacthookform={1}
                      name={CPropertyValidationDocumentKeys.date_file_aprocovici}
                      label="Fecha de ingreso"
                      disabled={aprocovici?.disabled}
                    />
                  </Grid>
                </Grid>
              )}
            </Grid>
          </ContentSection>
        </Grid>
      )}
    </Grid>
  );
}

export default Aprocovici;
